import type { AstApnTag, AstDefineTagParams } from "@omni/ads";

import { getApnTag } from ".";

const batcher = async (
  tags: AstDefineTagParams[],
  apnTag?: AstApnTag,
): Promise<void> => {
  if (typeof window === "undefined") {
    return;
  }
  const apntag = apnTag ? apnTag : await getApnTag();

  apntag.anq.push(function () {
    tags.forEach((tag) => {
      apntag.defineTag(tag);
    });
  });
};

export { batcher };
